import React from 'react';
import { IconProps } from '../types';
const MinecraftSpyglass: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="10" y="1" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="11" y="1" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(30, 101, 102, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(51, 144, 144, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(104, 189, 189, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(160, 86, 17, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(51, 144, 144, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(104, 189, 189, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="13" y="3" width="1" height="1" fill="rgba(104, 189, 189, 255)" />
<rect x="14" y="3" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(160, 86, 17, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(30, 101, 102, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(51, 144, 144, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(104, 189, 189, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(104, 189, 189, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(160, 86, 17, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(30, 101, 102, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(51, 144, 144, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(30, 101, 102, 255)" />
<rect x="14" y="5" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(126, 63, 57, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(126, 63, 57, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(168, 95, 88, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(244, 224, 99, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(83, 43, 11, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(126, 63, 57, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(168, 95, 88, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(168, 95, 88, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(126, 63, 57, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(222, 146, 58, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(83, 43, 11, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(85, 41, 37, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(168, 95, 88, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(126, 63, 57, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(85, 41, 37, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(85, 41, 37, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(83, 43, 11, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(83, 43, 11, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(160, 86, 17, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(85, 41, 37, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(85, 41, 37, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(83, 43, 11, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(160, 86, 17, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(83, 43, 11, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(126, 63, 57, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(189, 106, 40, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(160, 86, 17, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(83, 43, 11, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(126, 63, 57, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(126, 63, 57, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
<rect x="2" y="14" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
<rect x="3" y="14" width="1" height="1" fill="rgba(51, 23, 18, 255)" />
</svg>);
export default MinecraftSpyglass;